import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {EducationTableIndividualComponent} from "./components/education-individual-table/education-table-individual.component";
import {AddIdividualEducationComponent} from "./components/add-idividual-education/add-idividual-education.component";
import {AuthGuard} from "../../auth.guard";
import {AddGroupEducationComponent} from "./components/add-group-education/add-group-education.component";
import {AllEducationSessionComponent} from "./components/all-education-session/all-education-session.component";
import {
  EducationReportingDashboardComponent
} from "./education_reporting/education-reporting-dashboard/education-reporting-dashboard.component";
import {EducationChildReportComponent} from "./education-child-report/education-child-report.component";
import {EducationTableGroupComponent} from "./components/education-group-table/education-table-group.component";
import {FollowUpQuestionComponent} from "./components/follow-up-question/follow-up-question.component";
import {FollowUpTableComponent} from "./components/follow-up-question/follow-up-table/follow-up-table.component";
import {
  EducationObservationListComponent
} from "./components/educationObservation/education-observation-list/education-observation-list.component";
import {
  AddEditEducationObservationComponent
} from "./components/educationObservation/add-edit-education-observation/add-edit-education-observation.component";
import {
  ViewEducationObservationComponent
} from "./components/educationObservation/view-education-observation/view-education-observation.component";
import { WorkUpdateListComponent } from "./components/Work Update/work-update-list/work-update-list.component";
import {AddEditWorkUpdateComponent} from "./components/Work Update/add-edit-work-update/add-edit-work-update.component";
import {EducationSopComponent} from "./components/education-sop/education-sop/education-sop.component";
import {AddEditInductionComponent} from "./components/induction/add-edit-induction/add-edit-induction.component";
import {ViewInductionComponent} from "./components/induction/view-induction/view-induction.component";
import {InductionListComponent} from "./components/induction/induction-list/induction-list.component";
import {SpecialDayListComponent} from "./components/special-day/special-day-list/special-day-list.component";
import {AddEditSpecialDayComponent} from "./components/special-day/add-edit-special-day/add-edit-special-day.component";
import {ViewSpecialDayComponent} from "./components/special-day/view-special-day/view-special-day.component";
import {EducationMomListComponent} from "./components/education-mom/education-mom-list/education-mom-list.component";
import {
  AddEditEducationMomComponent
} from "./components/education-mom/add-edit-education-mom/add-edit-education-mom.component";
import {ViewEducationMomComponent} from "./components/education-mom/view-education-mom/view-education-mom.component";
import {
  EducationInductionTableComponent
} from "./components/induction/education-induction-table/education-induction-table.component";
import {EducationHighlightComponent} from "./components/education-highlight/education-highlight.component";



const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        component: AllEducationSessionComponent,
    children:[
        {path:'add-individual-education',
        component:AddIdividualEducationComponent,
            canActivate: [AuthGuard]
        }
    ]},
    {path:'add-individual-education',
        component:AddIdividualEducationComponent,
        canActivate: [AuthGuard]
    },
    {path:'add-group-education',
        component:AddGroupEducationComponent,
        canActivate: [AuthGuard]
    },
  {path:'dashboard',
    component:EducationReportingDashboardComponent,
    canActivate: [AuthGuard]
  },

    {path:'education-report',
        component:EducationChildReportComponent,
        canActivate: [AuthGuard]
    },
    {path:'individual',
        component:EducationTableIndividualComponent,
        canActivate: [AuthGuard]
    },

    {path:'group',
        component:EducationTableGroupComponent,
        canActivate: [AuthGuard]
    } ,
  {path:'follow-up-question',
        component:FollowUpQuestionComponent,
        canActivate: [AuthGuard]
    },
  {path:'follow-up-table',
        component:FollowUpTableComponent,
        canActivate: [AuthGuard]
    },
  {path:'follow-up-question/:id',
    component:FollowUpQuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-observation-list',
    component: EducationObservationListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-education-observation/:id',
    component: AddEditEducationObservationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'view-education-observation/:id',
    component: ViewEducationObservationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-education-observation',
    component: AddEditEducationObservationComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'work-update-list',
    component: WorkUpdateListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-work-update/:id',
    component: AddEditWorkUpdateComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-work-update',
    component: AddEditWorkUpdateComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-sop',
    component: EducationSopComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'induction-list',
    component: InductionListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-induction-table',
    component: EducationInductionTableComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-induction-table/:id',
    component: EducationInductionTableComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-induction',
    component: AddEditInductionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-induction/:id',
    component: AddEditInductionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'induction-view/:id',
    component: ViewInductionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'special-day-list',
    component: SpecialDayListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-special-day',
    component: AddEditSpecialDayComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-special-day/:id',
    component: AddEditSpecialDayComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'special-day-view/:id',
    component: ViewSpecialDayComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-mom-list',
    component: EducationMomListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'add-education-mom',
    component: AddEditEducationMomComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'edit-education-mom/:id',
    component: AddEditEducationMomComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-mom-view/:id',
    component: ViewEducationMomComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'education-highlight-list',
    component: EducationHighlightComponent,
    canActivate: [AuthGuard]
  },

]
//     [
//     {
//         path: '',
//         // redirectTo: 'categories',
//         // component: CounselingTableComponent,
//         component: AllSessionTablesComponent,
//         children: [
//             {
//                 path: 'add-assessment',
//                 component: AddAssessmentComponent
//             }
//         ]
//     },
//     {
//         path: 'assessments/add-assessment',
//         component: AddAssessmentComponent
//     },
//     {
//         path: 'add-individual-session',
//         pathMatch: "full",
//         component: AddIndividualSessionComponent
//     },
//     {
//         path: 'add-group-session',
//         pathMatch: "full",
//         component: AddGroupSessionComponent
//     },
//     // {
//     //   path: 'categories',
//     //   component: CounselingTableComponent,
//     //
//     // },
// ]

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forChild(routes),
        CommonModule
    ],
    exports: [RouterModule]
})
export class EducationRoutingModule {
}
